"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about-us" ref={ref} className="relative overflow-hidden bg-light-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center transition-all duration-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
          {}
          <div className="relative overflow-hidden rounded-lg shadow-medium">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1500413/img/about_us_team_portrait.png" alt="MANAGEMENT 101 LLC Team" className="w-full h-auto object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] hover:scale-[1.02]" />
          </div>

          {}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-foreground-light leading-tight">
              About MANAGEMENT 101 LLC
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              MANAGEMENT 101 LLC is a professional freight transportation arrangement firm based in Palmdale, California, delivering reliable logistics solutions that keep goods moving efficiently and on schedule. We coordinate and manage the full transportation process for businesses of all sizes, from small manufacturers to large distributors. Emphasizing precision, clarity, and care, we handle route planning, carrier selection, real‑time tracking, and compliance documentation.
            </p>
            <Link to="#" className="inline-block">
              <Button className="transition-transform duration-[120ms] hover:scale-[1.02] shadow-soft hover:shadow-medium hover:-translate-y-0.5" size="lg">
                Learn More About Us
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}